export default {"src":"/_next/static/media/idea_solution.8f6821f4.svg","height":284,"width":284};